import { FC } from 'react';
import styled from 'styled-components';
import { Card } from '../../../../style/essential-ui/Card';
import { Placeholder } from '../../../../style/essential-ui/Placeholder';

export const ContractModalPlaceholder: FC = () => {
  return (
    <Wrapper data-testid='loading'>
      <div>
        <span className='col-3 justify-content-middle'>
          <CarImageWrapper />
        </span>
        <span className='col-3'>
          <Placeholder height={5} width={93} top={1} />
          <Placeholder height={5} width={93} top={10} />
          <Placeholder height={12} width={93} top={10} />
          <Placeholder height={12} width={93} top={10} />
          <Placeholder height={12} width={93} top={10} />
          <Placeholder height={12} width={93} top={10} />
        </span>
        <svg
          width='260'
          height='120'
          viewBox='0 0 260 120'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <defs>
            <clipPath id='myClip'>
              <path
                d='M194.197 47.5C194.197 47.5 197.197 58.5 194.197 61.5C191.197 64.5 180.697 64.5 180.697 64.5C180.697 64.5 177.197 75.5 163.697 75.5C150.197 75.5 146.197 64.5 146.197 64.5H53.697C53.697 64.5 49.697 73 36.697 73C23.697 73 20.197 64.5 20.197 64.5C20.197 64.5 2.69701 63 0.697009 60C-1.30299 57.0001 1.19701 43.5001 5.69701 36.5C10.197 29.5 53.697 24.5 53.697 24.5C53.697 24.5 72.197 9.00004 78.697 5.50004C85.197 2.00004 134.197 -1.49996 149.697 2.00004C165.197 5.50004 177.197 14.5001 182.697 21C188.197 27.5 194.197 47.5 194.197 47.5Z'
                fill='black'
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <StyledDiv className='col-9'>
        <Placeholder height={20} width={93} top={0} />
        <Placeholder height={55} width={93} top={10} />
        <Placeholder height={20} width={93} top={10} />
      </StyledDiv>
    </Wrapper>
  );
};

export const Wrapper = styled(Card)`
  background: linear-gradient(
    ${(props) => props.theme.palette.white},
    ${(props) => props.theme.palette.gray}
  );
  height: 500px;
  width: 100%;
`;

const CarImageWrapper = styled.div`
  margin: 20px 0 0 30px;
  align-content: flex-end;
  justify-content: center;
  height: 120px;
  width: 260px;
  align-self: flex-end;
  background: linear-gradient(
    90deg,
    rgba(227, 227, 227, 1) 0%,
    rgba(182, 182, 182, 1) 7%,
    rgba(182, 182, 182, 1) 13%,
    rgba(227, 227, 227, 1) 25%
  );
  background-size: 900%;
  background-position: 100% 0%;
  animation: animation 1.8s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  clip-path: url(#myClip);

  @keyframes animation {
    0% {
      background-position: 100% 0%;
    }
    99.99% {
      background-position: -30% 0%;
    }
    100% {
      background-position: 100% 0%;
    }
  }
`;

const StyledDiv = styled.div`
  width: 100%;
`;
